const NUMBER_UNITS = ['', 'K', 'M'],
    regFormatFloat = /\d{1,3}(?=(\d{3})+\.\d+[^\d]?$)/g,
    regFormatInteger = /\d{1,3}(?=(\d{3})+[^\d]?$)/g,
    regFormatZero = /\.0+(?=([^\d]*$))/;
/**
 * 格式化number数据
 * @param {number} num 被格式化的数据
 * @param {boolean} units 是否需要单位(K,M)
 * @param {number} fixed 保留的小数位
 * @param {string} prefix 前缀
 * eg: fn(10000) -> 10,000
 * eg: fn(10000,true) -> 10K, fn(10000000,true) -> 10M
 * eg: numberFormat(1510,true,2) -> 1.51K
 * eg: fn(1000.213,false,2) -> 1000.21, fn(1000.123,true,2) —> 1K
 * eg: fn(10000,true,2,'$') -> $10K
 */
export default function (num, units, fixed, prefix = '') {
    if (isNaN(num)) return '';
    num = parseFloat(num);
    fixed = parseInt(fixed, 10);
    if (units) {
        if (isNaN(fixed)) fixed = 1;
        let idx = parseInt((parseInt(num).toFixed(0).length - 1) / 3),
            maxIdx = NUMBER_UNITS.length - 1;
        if (idx >= maxIdx) {
            idx = maxIdx;
            num = (num / Math.pow(1000, idx)).toFixed(fixed);
        } else {
            num = (num / Math.pow(1000, idx)).toFixed(fixed);
            if (num >= 1000) {
                num = (num / 1000).toFixed(fixed);
                idx += 1;
            }
        }
        num += NUMBER_UNITS[idx];
    } else if (!isNaN(fixed)) {
        num = num.toFixed(fixed);
    }
    num = num.toString().replace(regFormatZero, '');
    return (
        prefix +
        num.replace(
            num.indexOf('.') === -1 ? regFormatInteger : regFormatFloat,
            '$&,'
        )
    );
}
